var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7B4EF8",
    fillRule: "evenodd",
    d: "M7.32 10.232a.937.937 0 0 1 1.323.088l5.857 6.694 5.857-6.694a.937.937 0 1 1 1.411 1.235l-6.562 7.5a.938.938 0 0 1-1.412 0l-6.562-7.5a.94.94 0 0 1 .088-1.323",
    clipRule: "evenodd"
  })));
};
export default SvgArrow;